// Modules
import styled from "styled-components"

export const CompanyLogo = styled.img`
  height: auto;
  margin: 0;
  max-height: 40px;
  min-width: 50px;
  object-fit: scale-down;
  vertical-align: middle;
  width: 50px;
`
